import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { RdsApiService } from '@rds/shared-api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RdsDataProductDialogService } from '../../data-product-selection-dialog/data-product-dialog.service';
import { RdsDataProductGuard } from './data-product-guard.service';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * If a route is navigated to without a catalog and data product in the URL,
 * use the default if they are set, otherwise open the data product selection dialog
 *
 * @author Will Davis <will.davis@mtna.us>
 */
@Injectable({ providedIn: 'root' })
export class RdsEmptyDataProductGuardService extends RdsDataProductGuard implements CanActivate {
  constructor(dataProductDialog: RdsDataProductDialogService, rdsApiService: RdsApiService, router: Router, snackbar: MatSnackBar) {
    super(dataProductDialog, rdsApiService, router, snackbar);
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    // Once a catalog and data product are set, naviate using them as parameters
    return super.canActivate(next, state).pipe(
      map((canActivate) => {
        if (typeof canActivate === 'boolean') {
          return this.router.createUrlTree([`${state.url}/${this.rdsApiService.catalogId}/${this.rdsApiService.dataProductId}`]);
        } else {
          // If the response is a UrlTree, then it's trying to redirect already so go with it.
          // I.e. the user clicks "Full Search" on the data product selection dialog
          return canActivate;
        }
      })
    );
  }
}
